import React from "react";

import {
  PaziaInput,
  PaziaMultiSelect,
  IDropdownOption,
  PaziaFileDropzone,
} from "components/atoms";
import { TrainerFormHeader } from "./TrainerFormHeader";
import { TRAINER_FORM_FIELDS } from "./TrainerForm";
import { PaziaFromQuill } from "components/atoms/PaziaQuill/PaziaFromQuill";

interface TrainerFormRightProps {
  groupsOptions: IDropdownOption[];
}
export const TrainerFormRight = ({ groupsOptions }: TrainerFormRightProps): JSX.Element => {
  return (
    <div className="grid auto-rows-min grid-cols-3 gap-4">
      <TrainerFormHeader>Szczegółowe informacje</TrainerFormHeader>
      <PaziaMultiSelect
        label="Grupa"
        name={TRAINER_FORM_FIELDS.GROUPS}
        options={groupsOptions}
        className="col-span-3"
      />
      <div className="col-span-3">
        <PaziaInput name={TRAINER_FORM_FIELDS.SHORT_DESCRIPTION} label="Krótki opis" />
      </div>
      <div className="col-span-3">
        <PaziaFromQuill name={TRAINER_FORM_FIELDS.DESCRIPTION} label="Pełen opis" />
      </div>
      <TrainerFormHeader>Zdjęcia</TrainerFormHeader>
      <div className="col-span-3">
        <PaziaFileDropzone name={TRAINER_FORM_FIELDS.AVATAR} label="Zdjęcie główne" type="image" single />
      </div>
    </div>
  );
};
